import { Controller } from "@hotwired/stimulus"
import { createAlert } from "../scripts/createAlert"

let debounce = undefined;

export default class extends Controller {
  static targets = [ "parser", "idsInput" ]
  static values = {
    entityTeamId: Number
  }

  connect() {
    // console.log("Hello, Parsers Controller here!", this.element)
    // console.log(this.parserTargets);
  }

  toggleParser(event) {
    // No longer needed - parsers handle their own IDs independently
  }

  submitForm(event) {
    // event.preventDefault();

    if (debounce) {
      clearTimeout(debounce);
    }

    debounce = setTimeout(() => {
      const headers = new Headers();
      headers.append('X-CSRF-Token', document.querySelector('meta[name="csrf-token"]').content);
      headers.append('Content-Type', 'application/json');

      // Collect parser-specific IDs
      const parserIdsMap = {};
      if (this.hasIdsInputTarget) {
        this.idsInputTargets.forEach(input => {
          const parserId = input.dataset.parserId;
          const idsValue = input.value || '';
          if (parserId) {
            parserIdsMap[parserId] = idsValue;
          }
        });
      }

      let parserIds = this.parserTargets.filter(p => p.checked).map(p => p.dataset.parserId);

      fetch(`/entity/teams/${this.entityTeamIdValue}.json`, {
        method: 'PUT',
        body: JSON.stringify({
          entity_team: {
            parser_ids: parserIds,
            parser_ids_map: parserIdsMap
          }
        }),
        headers: headers
        })
        .then(response => response.json())
        .then(data => {
          // console.log(data);

          createAlert('success', 'Saved successfully');

          document.querySelector('#entity-layouts-tabs').setAttribute('reloadcontent', 'true');

          // do a full page reload so that the Recap Layout tab is updated with the selected parser
          // document.cookie = `flash_notice=Saved successfully; path=/`;
          // window.location.reload();

          // remove the team IDs in any parsers that are not checked anymore
          this.parserTargets.filter(p => !p.checked).forEach(elm => {
            const parserId = elm.dataset.parserId;
            let id_input = document.querySelector(`#parser_ids_${parserId}`);
            if (id_input) {
              id_input.value = '';
            }
          });

        });

    }, 1000);
  }

}
